import createIcon from '../../createIcon';

/**
 * @component @name Pageview
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTEuNSA5QzEwLjEyIDkgOSAxMC4xMiA5IDExLjVDOSAxMi44OCAxMC4xMiAxNCAxMS41IDE0QzEyLjg4IDE0IDE0IDEyLjg4IDE0IDExLjVDMTQgMTAuMTIgMTIuODggOSAxMS41IDlaTTIwIDRINEMyLjkgNCAyIDQuOSAyIDZWMThDMiAxOS4xIDIuOSAyMCA0IDIwSDIwQzIxLjEgMjAgMjIgMTkuMSAyMiAxOFY2QzIyIDQuOSAyMS4xIDQgMjAgNFpNMTYuNzkgMTguMjFMMTMuODggMTUuM0MxMy4xOSAxNS43NCAxMi4zNyAxNiAxMS40OSAxNkM5LjAxIDE2IDcgMTMuOTkgNyAxMS41QzcgOS4wMSA5LjAxIDcgMTEuNSA3QzEzLjk5IDcgMTYgOS4wMSAxNiAxMS41QzE2IDEyLjM4IDE1Ljc0IDEzLjE5IDE1LjMgMTMuODlMMTguMjEgMTYuNzlMMTYuNzkgMTguMjFaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Pageview = createIcon('Pageview', [
  [
    'path',
    {
      d: 'M11.5 9C10.12 9 9 10.12 9 11.5C9 12.88 10.12 14 11.5 14C12.88 14 14 12.88 14 11.5C14 10.12 12.88 9 11.5 9ZM20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6C22 4.9 21.1 4 20 4ZM16.79 18.21L13.88 15.3C13.19 15.74 12.37 16 11.49 16C9.01 16 7 13.99 7 11.5C7 9.01 9.01 7 11.5 7C13.99 7 16 9.01 16 11.5C16 12.38 15.74 13.19 15.3 13.89L18.21 16.79L16.79 18.21Z',
      key: 'vxod6h',
    },
  ],
]);

export default Pageview;
